import { WizardStepStatus } from "./WizardStepStatus";
import { StepProps } from 'ant-design-vue'
import { WizardStepContent } from "./WizardStepContent";
import { Component } from "vue";


export type WizardStepType = Record<string, string>;

export enum WizardStepStatusType {
    Good = "good",
    Changes = "hasUncommittedChanges",
    Errors = "hasErrors",
    Warnings = "hasWarnings",
    Unknown = "unknown"
}

export abstract class WizardStep<TSharedModel, TStepType extends string | number = string | number> implements Partial<StepProps> {

    public status: WizardStepStatus = WizardStepStatus.Waiting;
    public disabled?: boolean;
    public isLoading?: boolean;
    public loadingMessage?: string;
    public statusType?: WizardStepStatusType = WizardStepStatusType.Unknown;
    public statusMessage?: string;
    public abstract statusComponent?: Component
    public abstract type: TStepType;
    public abstract title: string;
    public abstract icon: any;
    public abstract stepContent: WizardStepContent<TSharedModel> | Array<WizardStepContent<TSharedModel>>;

}